/**
 * Ambient page gradients and grid for fidusfinance.com.
 * Section components use teal accents.
 */
export const MAIN_BODY_BACKDROP =
  'linear-gradient(180deg,#070b12 0%,#071018 8%,#0a1526 18%,#081018 28%,#0c1829 38%,#07101d 48%,#090f1a 56%,#101e30 64%,#070f18 74%,#06101a 86%,#070b12 100%)';

export const SECTION_ACCENTS = {
  stats:
    'radial-gradient(circle at 50% 0%, rgba(16,185,129,0.09), transparent 46%), radial-gradient(circle at 88% 100%, rgba(59,130,246,0.07), transparent 50%)',
  partners:
    'radial-gradient(circle at 12% 18%, rgba(59,130,246,0.14), transparent 40%), radial-gradient(circle at 90% 82%, rgba(16,185,129,0.14), transparent 40%)',
  about:
    'radial-gradient(circle at 30% 10%, rgba(148,163,184,0.10), transparent 46%), radial-gradient(circle at 94% 92%, rgba(59,130,246,0.09), transparent 44%)',
  services:
    'radial-gradient(circle at 80% 0%, rgba(16,185,129,0.18), transparent 36%), radial-gradient(circle at 20% 85%, rgba(59,130,246,0.12), transparent 38%)',
  security:
    'radial-gradient(circle at 72% 20%, rgba(99,102,241,0.11), transparent 44%), radial-gradient(circle at 18% 80%, rgba(16,185,129,0.11), transparent 44%)',
  locations:
    'radial-gradient(circle at 88% 12%, rgba(16,185,129,0.12), transparent 40%), radial-gradient(circle at 10% 78%, rgba(59,130,246,0.10), transparent 44%)',
  contact:
    'radial-gradient(circle at 52% 100%, rgba(16,185,129,0.09), transparent 48%), radial-gradient(circle at 8% 12%, rgba(59,130,246,0.10), transparent 42%)',
} as const;

export type SectionAtmosphereVariant = keyof typeof SECTION_ACCENTS;

export function MainBodyBackdrop() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-20"
        style={{ backgroundImage: MAIN_BODY_BACKDROP }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 bg-[linear-gradient(90deg,rgba(232,237,228,0.035)_1px,transparent_1px),linear-gradient(180deg,rgba(232,237,228,0.035)_1px,transparent_1px)] bg-[size:72px_72px] opacity-[0.26]"
      />
    </>
  );
}

export function SectionAtmosphere({ variant }: { variant: SectionAtmosphereVariant }) {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 z-0"
      style={{ backgroundImage: SECTION_ACCENTS[variant] }}
    />
  );
}

/** Section eyebrow tracking */
export const TYPE_SECTION_EYEBROW =
  'text-[0.65rem] font-semibold uppercase tracking-[0.28em] text-[#d6ddcf]/85';

/** Teal label style */
export const TYPE_LABEL_CAPS = 'text-xs font-semibold uppercase tracking-[0.22em] text-teal-200/90';
